import { render } from "./MyDataTable.vue?vue&type=template&id=99ecbabe"
import script from "./MyDataTable.vue?vue&type=script&lang=js"
export * from "./MyDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__